module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"tab":{"all":"전체","video":"동영상"}}}')
  delete Component.options._Ctor
}
